import * as React from 'react';
/** @private Internal Usage. Only used for Dropdown component. Do not use this in your production. */

var OverrideContext = /*#__PURE__*/React.createContext(null);
export default OverrideContext;